export const getItemStockCode = (itemData, selectedItemPayer) =>
  itemData?.non_standard_code ||
  selectedItemPayer?.agreed_code ||
  selectedItemPayer?.non_standard_code ||
  itemData?.standard_code ||
  ''

export const isOutOfStockItem = itemData =>
  Boolean(itemData?.is_stock) &&
  itemData?.stock !== undefined &&
  itemData?.stock !== null &&
  Number(itemData?.stock) < 1

export const isLowStockItem = itemData =>
  Boolean(itemData?.is_stock) &&
  itemData?.stock !== undefined &&
  itemData?.stock !== null &&
  Number(itemData?.stock) > 0 &&
  Number(itemData?.stock) < 10

export const isQuantityOverStock = (itemData, quantity) =>
  Boolean(itemData?.is_stock) &&
  itemData?.stock !== undefined &&
  itemData?.stock !== null &&
  Number(quantity) > Number(itemData?.stock)

export const showStockLimitToast = (toast, stock) => {
  toast.success(`Only ${stock} in stock`, {
    id: 'stock-limit-warning',
    icon: '⚠️'
  })
}

export const getOutOfStockMessage = (itemData, selectedItemPayer) => {
  const itemCode = getItemStockCode(itemData, selectedItemPayer)
  return `This item does not have stock${itemCode ? `: ${itemCode}` : ''}`
}

export const getLowStockMessage = itemData =>
  `Low stock${itemData?.stock !== undefined ? `: ${itemData.stock}` : ''}`
